import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import { BasicSelect } from 'vue-search-select';
import PageTracker from '../../../common/PageTrackerHelper';
import Paginate from 'vuejs-paginate';
import DatePicker from 'vue2-datepicker';
import commonService from '../../../common/common.service';
import swal from 'sweetalert2';
var XLSX = require("xlsx");
const moment = require('moment');

export default {
  name: 'podsearch',
  components: {
    VueElementLoading, Paginate, swal, BasicSelect, Validator, PageTracker, DatePicker,
  },
  mixins: [PageTracker],
  data: function () {
    return {
      isLoading: false,
      MandatoryFlag: false,
      ClientName: '',
      Clientdata: { value: "", text: "" },
      ClientArray: [],
      hubzoneid: '',
      hubZoneList: [],
      HubZonedata: { value: "", text: "" },
      hubID: '',
      localuserid: '',
      hubList: [],
      hubIDobj: { value: "", text: "" },
      ShipmentType: '',
      ShipmentTypedata: {},
      ShipmentTypeArray: [
        { value: 1, text: "RTO" },
        { value: 2, text: "DTO" },
        { value: 3, text: "RTODTO" },
        { value: 4, text: "forward" }
      ],
      BatchId: '',
      POId: '',
      AWBNumbers: '',
      PODDetails: [],
      selectedItems: [],
      ShowTable: false,
      validDateRangeFrom: null,
      todaysDate: null,
      FromDate: '',
      ToDate: '',
      selectedDtpFromDate: null,
      validDateRange: null,
      pageno: 0,
      pagecount: 1,
      selectedItems: [],
      downloadDetails: [],
      showImage: false,
      selectedItemdata: '',
      previewImageModel: false,
      displayImageInBox: '',
      srLoader: '',
      podimagepath: '',
      podShippingid: '',
      PODZoneName: '',
      PODHubName: '',
      PODClientName: '',
      ClientNameFilter: false,
      VendorFilter: false,
      ShippingIdFilter: false,
      ClientNAme1: '',
      VendorNAme1: '',
      ShippingId1: '',
      TableDetails: [],
      EmptyResult: false,
      currentInvalidShipment: [],
      currentValidShipment: [],
      currentValidBatch: '',
      currentInvalidBatch: '',
      downloadBtnEnable: true,
      totalRecords : 0,
      downloadDetails : [],
      fromDateEnable : true,
      loader: '<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
      userDataKey : '',
    }
  },

  mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.getClientList();
    this.getHubZoneData()
    this.getHubList("hubList");

  },
  filters: {
    moment: function (date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    jsUcfirst: function (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    batchCreatedDateFormat: function (date) {
      if (date == null) return ''
      return moment(date).format('DD-MM-YYYY');
    }
  },

  methods: {
    formatDatey(datef) {
      if (datef) {
          return moment.utc(datef).format('DD-MM-YYYY HH:mm:ss').valueOf();
      } else {
          return 'NA'
      }
    },
    OK(){
      this.EmptyResult = false;
    },
    //to get clientName list dropdown
    imgClick() {
      this.showImage = true
    },
    hideImage() {
      this.showImage = false
    },
    getclients(obj) {
      this.fromDateEnable = false
      this.Clientdata = obj
      this.ClientName = this.Clientdata.value
      if (this.FromDate && this.ToDate && this.MandatoryFlag == true) {
        this.MandatoryFlag = false
      } else if (this.FromDate == '' && this.ToDate == '' && this.MandatoryFlag == false) {
        this.MandatoryFlag = true
      }
    },
    getClientList() {
      this.srLoader = this.loader
      axios.get(apiUrl.api_url + 'external/getclientlist', {})
        .then((response) => {
          if (response.data.code === 200) {
            this.clientArrayList = response.data.data;
            for (var i = 0; i < this.clientArrayList.length; i++) {
              this.ClientArray.push({
                value: this.clientArrayList[i].ClientMasterID,
                text: `${this.clientArrayList[i].CompanyName}`
              })
            }
            this.srLoader = ''
          }
          else {
            this.ClientArray = [];
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },

    //Shipment type dropdown obj
    ShipmentTypeObj(obj) {
      this.fromDateEnable = false
      this.ShipmentTypedata = obj;
      this.ShipmentType = obj.text;
      if (this.FromDate && this.ToDate && this.MandatoryFlag == true) {
        this.MandatoryFlag = false
      } else if (this.FromDate == '' && this.ToDate == '' && this.MandatoryFlag == false) {
        this.MandatoryFlag = true
      }
    },
    clientClickupArrow() {
      this.TableDetails.sort((a, b) => a.ClientName.localeCompare(b.ClientName))
    },
    clientClickDownArrow() {
      this.TableDetails.sort((a, b) => a.ClientName.localeCompare(b.ClientName))
      this.TableDetails.reverse()
    },
    vendorClickupArrow() {
      this.TableDetails.sort((a, b) => a.VendorName.localeCompare(b.VendorName))
    },
    vendorClickDownArrow() {
      this.TableDetails.sort((a, b) => a.VendorName.localeCompare(b.VendorName))
      this.TableDetails.reverse()
    },
    shippingClickupArrow() {
      this.TableDetails.sort((a, b) => a.ShippingID.localeCompare(b.ShippingID))
    },
    shippingClickDownArrow() {
      this.TableDetails.sort((a, b) => a.ShippingID.localeCompare(b.ShippingID))
      this.TableDetails.reverse()
    },
    mpsClickupArrow() {
      this.TableDetails.sort((a, b) => a.mpsGroupId.localeCompare(b.mpsGroupId))
    },
    mpsClickDownArrow() {
      this.TableDetails.sort((a, b) => a.mpsGroupId.localeCompare(b.mpsGroupId))
      this.TableDetails.reverse()
    },
    //HUB Zone dropdown
    getHubZone(obj) {
      this.fromDateEnable = false
      this.HubZonedata = obj;
      this.hubzoneid = obj.value;
      if (this.FromDate && this.ToDate && this.MandatoryFlag == true) {
        this.MandatoryFlag = false
      } else if (this.FromDate == '' && this.ToDate == '' && this.MandatoryFlag == false) {
        this.MandatoryFlag = true
      }
      this.zonename = obj.text;
      this.zoneid = obj.value;
      this.hubID = '';
      this.hubIDobj = { value: "", text: "" }
      this.hubList = []
      if (this.zoneid) {
        this.getHubList(this.zoneid);
      }
    },
    getHubZoneData() {
      this.srLoader = this.loader
      axios.get(apiUrl.api_url + 'external/gethubzonelist', {})
        .then((response) => {
          if (response.data.code == 200) {
            response.data.data.map(hubzonename => {
              this.hubZoneList.push({
                value: hubzonename.hubzoneid,
                text: hubzonename.hubzonename
              });
            });
            this.srLoader = ''
          }
          else {
            this.hubZoneList = [];
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },


    //Hub Name dropdown obj
    selectHub(obj) {
      this.fromDateEnable = false
      this.hubIDobj = obj;
      this.hubID = obj.value;
      if (this.FromDate && this.ToDate && this.MandatoryFlag == true) {
        this.MandatoryFlag = false
      } else if (this.FromDate == '' && this.ToDate == '' && this.MandatoryFlag == false) {
        this.MandatoryFlag = true
      }
    },

    getHubList(hubZoneID) {
      this.srLoader = this.loader
      let url = 'UpdateShipment/gethublist';
      if (hubZoneID != 'hubList') url = `external/getzonewisehublist?zoneid=${hubZoneID}`;
      axios.get(apiUrl.api_url + url)
        .then(async (response) => {
          if (response.data.code == 200) {
            await response.data.data.forEach(async (item, i) => {
              await this.hubList.push({
                value: item.HubID,
                text: item.HubName
              })
            });
            this.hubList.sort(function (sortFirst, sortSecond) {
              var hubNameFirst = sortFirst.text.toLowerCase(), hubNameSecond = sortSecond.text.toLowerCase()
              if (hubNameFirst < hubNameSecond) //sort string ascending
                return -1
              if (hubNameFirst > hubNameSecond)
                return 1
              return 0 //default return value (no sorting)
            });
            this.srLoader = ''
          }
          else {
            this.hubList = [];
          }
        })
        .catch((httpException) => {
          this.$alertify.error("Hub List not found");
          console.error('exception is:::::::::', httpException)
        })
    },

    //Table header checkbox Function
    selectItems(ev) {
      this.selectedItems = [];
      if (ev.target.checked == true) {
        this.downloadBtnEnable = false
        this.PODDetails.map(obj => {
          this.selectedItems.push(obj)
        })
        // for (let i in this.PODDetails) {
        //   this.selectedItems.push(this.PODDetails[i]);
        // }
      } else {
        this.downloadBtnEnable = true
        this.PODDetails.map(obj => {
          this.selectedItems.pop(obj)
        })
        // for (let i in this.PODDetails) {
        //   this.selectedItems.pop(this.PODDetails[i]);
        // }
      }
    },
    //Table data checkbox Function
    setcheckbox(event) {      
      if (event.target.checked == false) {
        this.downloadBtnEnable = true
        this.selectedItemdata = false;
      } else {
        this.downloadBtnEnable = false
      }
    },
    //Checkbox selected download
    EditPage(data) {
      this.downloadBtnEnable = false
      if (this.selectedItems.includes(data)) {
        const index = this.selectedItems.indexOf(data)
        this.selectedItems.splice(index, 1)
      } else {
        this.selectedItems.push(data)
      }
    },

    //PAgination function
    getPaginationData(pageNum) {
      this.pageno = (pageNum - 1) * 10;
      this.SearchPOD();
    },

    //URL Image
    getImage(PODPath) {
      if (PODPath) {
        window.open(PODPath);
      } else {
        this.$alertify.error("No image Available");
      }
    },

    //From date validations
    checkFromDate() {
      this.MandatoryFlag = false
      this.validDateRangeFrom = moment.utc(this.ToDate).format("YYYY-MM-DD").valueOf();
      this.todaysDate = moment.utc().format('YYYY-MM-DD').valueOf();
      this.selectedDeliveryDate = moment.utc(this.selectedDtpFromDate).add(4, 'days').format('YYYY-MM-DD').valueOf();
      if (this.ToDate > this.selectedDeliveryDate) {
        this.$alertify.error("Please select date range should be less than 5 day")
        this.ToDate = null;
      }
      if (this.ToDate != null) { this.MandatoryFlag = false }
      if (this.ToDate > this.todaysDate) {
        this.$alertify.error("Please select less than todays date")
        this.ToDate = null;
      }
    },
    //To date validations
    checkToDate() {
      this.MandatoryFlag = false
      this.ToDate = null;
      this.todaysDate = moment.utc().format('YYYY-MM-DD').valueOf();
      this.selectedDtpFromDate = moment.utc(this.FromDate).format("YYYY-MM-DD").valueOf();
      this.selectedDeliveryDate = moment.utc(this.selectedDtpFromDate).add(4, 'days').format('YYYY-MM-DD').valueOf();

      if (this.selectedDtpFromDate <= this.todaysDate && this.selectedDtpFromDate <= this.selectedDeliveryDate) {
        this.validDateRange = this.selectedDeliveryDate
        this.MandatoryFlag = false
      } else {
        this.validDateRange = this.todaysDate
        this.MandatoryFlag = false
      }
      if (this.FromDate != null) { this.MandatoryFlag = false }
    },

    onlyNumber: function ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 8 && keyCode !== 44) {
        $event.preventDefault();
      }
    },

    //Search POD functionality
    async SearchPOD() {
      this.ShowTable = true;
      this.isLoading = true;
      if (this.ShipmentType !== '' || this.BatchId !== '' || this.POId !== '' || this.AWBNumbers !== '') {
        var AWBNumbersArray = []
        var BatchIdArray = []
        if (this.AWBNumbers.length > 0) {
          AWBNumbersArray = `${this.AWBNumbers.trim().replace(/[^,0-9]/g, ',')}`

          await commonService.validateParentAwbArray(this.AWBNumbers.split(/[\n,]+/)).then(shipmentValidation => {
            if (shipmentValidation) {
              this.EmptyResult = false;
              let validShipment = shipmentValidation.valid
              let invalidShipment = shipmentValidation.invalid

              if (invalidShipment && invalidShipment.length > 0) {
                this.EmptyResult = true;
                this.currentInvalidShipment = invalidShipment.toString();
                this.isLoading = false;
                this.ShowTable = false;
              } else {
                this.currentValidShipment = validShipment;
                this.searchPODData(validShipment).then(result => {
                  if (result.code == 200) {

                  } else {
                    // this.$alertify.error("Data not found");
                    this.ShowTable = false;
                    this.isLoading = false;
                  }
                })
              }
            }
          })
        }
        if (this.BatchId.length > 0) {
          BatchIdArray = `${this.BatchId.trim().replace(/[^,0-9]/g, ',')}`
          await commonService.validateBatchId(this.BatchId.split(/[\n,]+/)).then(batchValidation => {
            if (batchValidation) {
              this.EmptyResult = false;
              let validBatch = batchValidation.valid
              let invalidBatch = batchValidation.invalid

              if (invalidBatch && invalidBatch.length > 0) {
                this.EmptyResult = true;
                this.currentInvalidBatch = invalidBatch.toString();
                this.isLoading = false;
                this.ShowTable = false;
              } else {
                this.currentValidBatch = validBatch;
                this.searchPODData(validBatch).then(result => {
                  if (result.code == 200) {

                  } else {
                    // this.$alertify.error("Data not found");
                    this.ShowTable = false;
                    this.isLoading = false;
                  }
                })
              }
            }
          })
        }
        // if ( this.ShipmentType != '' || this.POId !== '' ) {
        this.searchPODData()
          .then(result => {
            if (result.code == 200) {
              this.$alertify.success("Data Display Successfully");
            } else {
              this.PODDetails = [];
              this.TableDetails = [];
              this.$alertify.error("Data not found");
              this.ShowTable = false;
              this.isLoading = false;
            }
          })
        // }
      } else if (this.FromDate == '' || this.ToDate == '') {
        this.ShowTable = false;
        this.$alertify.error("Please select From Date and To Date")
        this.isLoading = false;
      } else {
        this.searchPODData()
          .then(result => {
            if (result.code == 200) {
            } else {
              this.PODDetails = [];
              this.TableDetails = [];
              this.$alertify.error("Data not found");
              this.ShowTable = false;
              this.isLoading = false;
            }
          })
      }
    },

    async searchPODData() {
      return new Promise(async (resolve, reject) => {
        try {
          let inputPayload = {
            "ClientID": this.ClientName,
            "HubZoneID": this.hubzoneid,
            "HubId": this.hubID,
            "ShipmentType": this.ShipmentType,
            "StartDate": this.FromDate,
            "EndDate": this.ToDate,
            "BatchId": this.currentValidBatch.toString() || '',
            "POId": this.POId,
            "Shipments": this.currentValidShipment || [],
            "pageSize": 10,
            "pageNo": this.pageno
          }
          axios({
            method: 'POST',
            url: apiUrl.api_url + 'PODSearchReport/list',
            data: inputPayload
          })
            .then(result => {
              if (result.data.code == 200) {
                this.PODDetails = result.data.data
                this.TableDetails = this.PODDetails
                for (let i = 0; i < this.TableDetails.length; i++) {
                  if (this.TableDetails[i].mpsGroupId == null) {
                    this.TableDetails[i].mpsGroupId = "NA"
                  }
                }
                this.TableDetails.sort((a, b) => a.mpsGroupId.localeCompare(b.mpsGroupId))
                this.ShowTable = true;
                this.isLoading = false;
                this.totalRecords = result.data.totalCount
                this.pagecount = Math.ceil(this.totalRecords / 10)
                return resolve({
                  code: 200,
                  message: "Record Downloaded Successfully"
                })
              } else {
                this.isLoading = true;
                this.PODDetails = [];
                this.TableDetails = [];
                this.isLoading = false;
                return resolve({
                  code: 201,
                  message: "Record Not Downloaded Successfully"
                })
              }
            })
        } catch (err) {
          this.isLoading = false
          this.PODDetails = [];
          this.TableDetails = [];
          console.log(err);
          return reject({
            code: 201,
            message: "Record Not Downloaded Successfully"
          })
        }
      })
    },

    // To download results functions
    downloadData() {
      this.isLoading = true;
      if (this.PODDetails.length == 0) {
        this.$alertify.alert("No data", "No data available for download.");
      }
      if (this.selectedItems.length > 0) {
        for (let i = 0; i < this.selectedItems.length; i++) {
          if (this.selectedItems[i].mpsGroupId == null) {
            this.selectedItems[i].mpsGroupId = "NA"
          }
          this.selectedItems[i].ShipmentDeliveryDate = this.formatDatey(this.selectedItems[i].ShipmentDeliveryDate)
        }
        this.getDownloadXlsxData(this.selectedItems);
      } else {
        this.getDownloadXlsxData(this.PODDetails)
      }
      this.isLoading = false;
    },
    downloadAllData() {
      this.isLoading = true;
      return new Promise(async (resolve, reject) => {
        try {
          let inputPayload = {
            "ClientID": this.ClientName,
            "HubZoneID": this.hubzoneid,
            "HubId": this.hubID,
            "ShipmentType": this.ShipmentType,
            "StartDate": this.FromDate,
            "EndDate": this.ToDate,
            "BatchId": this.currentValidBatch.toString() || '',
            "POId": this.POId,
            "Shipments": this.currentValidShipment || [],
          }
          axios({
            method: 'POST',
            url: apiUrl.api_url + 'DownloadPODSearch/list',
            data: inputPayload
          })
          .then(result => {
            if (result.data.code == 200) {
              this.downloadDetails = result.data.data
              for (let i = 0; i < this.downloadDetails.length; i++) {
                if (this.downloadDetails[i].mpsGroupId == null) {
                  this.downloadDetails[i].mpsGroupId = "NA"
                }
                this.downloadDetails[i].ShipmentDeliveryDate = this.formatDatey(this.downloadDetails[i].ShipmentDeliveryDate)
              }
              this.getDownloadXlsxData(this.downloadDetails)
              this.isLoading = false;
            }
          })
        } catch (err) {
          console.log(err);
          return reject({
            code: 201,
            message: "Record Not Downloaded Successfully"
          })
        }
      })
    },
    getDownloadXlsxData(result) {
      const data = XLSX.utils.json_to_sheet(result);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, 'data')
      let filename = 'podReport_' + this.FromDate + 'To' + this.ToDate + '.xlsx';
      XLSX.writeFile(wb, filename);
      this.selectedItems = [];
    },
    async viewPodImage(podimagepath, podShippingid, PODZoneName, PODHubName, PODClientName) {
      try {
        this.podimagepath = podimagepath
        this.podShippingid = podShippingid
        this.PODZoneName = PODZoneName
        this.PODHubName = PODHubName
        this.PODClientName = PODClientName
        if (this.podimagepath != "") {
          this.displayImageInBox = this.podimagepath
          this.previewImageModel = true
          this.isLoading = false
        } else {
          this.$alertify.error("POD Image not found")
          this.previewImageModel = false
          this.isLoading = false
        }

      } catch (error) {
        console.log("error", error);
      }
    },

    // Download all images for perticular shipping Id
    async downloadPODImage(podData) {
      this.downloadPODimg = podData;
      if (this.downloadPODimg != "") {
        var link = document.createElement('a');
        link.href = this.downloadPODimg;
        link.setAttribute('target', '_blank');
        window.open(this.downloadPODimg, '_blank');
        link.remove();
        return true;
      } else {
        this.$alertify.error("POD Image not Found.")
        return false;
      }
    },

    closeModelPreviewImage() {
      this.previewImageModel = false
    },
    async ResetFields() {
      this.ClientName = '',
      this.Clientdata = { value: "", text: "" },
      this.hubzoneid = ''
      this.hubID = '',
      this.ShipmentType = '',
      this.FromDate = null || '',
      this.ToDate = null || '',
      this.BatchId = '',
      this.POId = '',
      this.currentValidShipment = '',
      this.currentValidBatch = ''
    },

    FilterClientname() {
      this.ClientNameFilter = true
    },
    FilterVendor() {
      this.VendorFilter = true
    },
    FilterShippindId() {
      this.ShippingIdFilter = true
    },

    cancle() {
      this.ClientNameFilter = false;
      this.ClientNAme1 = '';
      this.ShippingId1 = '';
      this.ShippingIdFilter = false;
      this.VendorNAme1 = '';
      this.VendorFilter = false;
    },

    FilterSearch() {
      let FilterData = []
      if (this.ClientNAme1) {
        let ClientNameCount = 0
        for (var i = 0; i < this.PODDetails.length; i++) {
          if (this.PODDetails[i].ClientName !== this.ClientNAme1) {
            ClientNameCount++;
            if (ClientNameCount == this.PODDetails.length) {
              this.$alertify.error("Data Not Found");
              this.ShowTable = false;
              this.isLoading = false;
              break;
            }
          }
          else {
            FilterData.push(this.PODDetails.find(o => o.ClientName === this.ClientNAme1))
          }
        }
        if (FilterData.length > 0) {
          this.$alertify.success("Client Name Searched Successfully");
        }
      }
      else if (this.ShippingId1) {
        let shippingIdcount = 0
        for (var i = 0; i < this.PODDetails.length; i++) {
          if (this.PODDetails[i].ShippingID !== this.ShippingId1) {
            shippingIdcount++;
            if (shippingIdcount == this.PODDetails.length) {
              this.$alertify.error("Data Not Found");
              this.ShowTable = false;
              this.isLoading = false;
              break;
            }
          }
          else {
            FilterData.push(this.PODDetails.find(o => o.ShippingID === this.ShippingId1))
          }
        }
        if (FilterData.length > 0) {
          this.$alertify.success("ShippingID Searched Successfully");
        }
      }
      else if (this.VendorNAme1) {
        let vendorcount = 0
        for (var i = 0; i < this.PODDetails.length; i++) {
          if (this.PODDetails[i].VendorName !== this.VendorNAme1) {
            vendorcount++;
            if (vendorcount == this.PODDetails.length) {
              this.$alertify.error("Data Not found");
              this.ShowTable = false;
              this.isLoading = false;
              break;
            }
          }
          else {
            FilterData.push(this.PODDetails.find(o => o.VendorName === this.VendorNAme1))
          }
        }
        if (FilterData.length > 0) {
          this.$alertify.success("Vendor Name Searched Successfully");
        }
      }
      else {
        this.$alertify.error("Data Not Found");
        this.ShowTable = false;
        this.isLoading = false;
      }
      this.TableDetails = FilterData;
      this.ClientNameFilter = false;
      this.ClientNAme1 = '';
      this.ShippingId1 = '';
      this.ShippingIdFilter = false;
      this.VendorNAme1 = '';
      this.VendorFilter = false;
    },

    Reset() {
      this.ShowTable = false;
      this.MandatoryFlag = false;
      this.BatchId = '',
      this.POId = '',
      this.AWBNumbers = '',
      this.AWBNumbersArray = [],
      this.isLoading = false;
      this.selectedItems = [],
      this.ShipmentType = '',
      this.ShipmentTypedata = { value: "", text: "" },
      this.FromDate = null || '',
      this.ToDate = null || '',
      this.validDateRange = null,
      this.todaysDate = null,
      this.ClientName = '',
      this.Clientdata = { value: "", text: "" },
      this.hubID = '',
      this.hubIDobj = { value: "", text: "" }
      this.PODDetails = [],
      this.TableDetails = [],
      this.selectedItems1 = '',
      this.currentValidShipment = [],
      this.currentInvalidShipment= [],
      this.currentValidBatch = '',
      this.currentInvalidBatch ='',
      this.hubzonename = "",
      this.HubZonedata = { value: "", text: "" }
      this.hubzoneid = { id: "", text: "" },
      this.hubzoneid = '',
      this.hubList = [];
      this.fromDateEnable = true
      this.getHubList("hubList");
    },

  }
}


// WEBPACK FOOTER //
// ./src/views/components/podsearch/podsearch.component.js